// 利用者一覧用フィールド
import * as React from 'react';
import * as UserListField from '../constants/UserListField';
import * as PropTypes from 'prop-types';
import { getCurrentTime, convertTime } from '../utils/dateUtil';
import * as MoffCheckConst from '../constants/MoffCheck';
import * as InterestCheckConst from '../constants/InterestCheck';

export enum Type {
  None = 0,
  // ロコモ予防トレーニング.
  Locomo,
  // 日常生活動作トレーニング.
  Adl,
  // 個別機能訓練に関する記録.
  Kiroku,
  // モフトレ通信.
  MoffPress,
  // モフトレチェック.
  MoffCheck,
  // 居宅訪問.
  HomeVisit,
  // 興味関心チェック.
  InterestCheck,
  // 機能訓練レポート.
  LiterallyReport,
}

// 利用者一覧の表のヘッダー部分.
export const userListHeader = Object.keys(UserListField.LocomoModel).map((key) => {
  return (
    <th key={key} scope="col">{UserListField.LocomoModel[key]}</th>
  );
});

// 興味関心チェック用利用者・モフトレチェック・記録用・利用者一覧の表のヘッダー部分.
export const kirokuUserListHeader = Object.keys(UserListField.KirokuModel).map((key) => {
  return (
    <th key={key} scope="col">{UserListField.KirokuModel[key]}</th>
  );
});

interface UserSelectBodyProps extends React.Props<{}> {
  // UserSelectLocomoから渡されたパラメータ
  users: UserListField.User[];
  type: Type;

  // モフトレチェックのみ.
  moffCheckActions?: any;
  // latest用.
  moffCheckCount?: any;
  // 興味関心チェックのみ.
  interestCheckActions?: any;
  interestCheck?: any;
}

// 利用者一覧の表のフィールド表示用コンポーネント
export class UserSelectBody extends React.Component<UserSelectBodyProps, {}> {
  urlBase: string;

  // あとから日付を入れるための仕組み.
  refElements: HTMLElement[] = [];

  /**
   * render()直前の処理.
   *
   * @memberof UserSelectBody
   */
  componentWillMount() {
    switch (this.props.type) {
      case Type.Locomo:
        this.urlBase = 'locomo';
        break;
      case Type.Adl:
        this.urlBase = 'adl';
        break;
      case Type.Kiroku:
        this.urlBase = 'kiroku';
        break;
      case Type.MoffPress:
        this.urlBase = 'press_select_month';
        break;
      case Type.MoffCheck:
        this.urlBase = 'moff_check_select_month';
        // モフトレチェック.
        this.runAPI(Type.MoffCheck);
        break;
      case Type.HomeVisit:
        // 居宅訪問はurlBaseが使われることはない.
        this.urlBase = 'home_visit_print';
        break;
      case Type.InterestCheck:
        // 興味関心チェックはurlBaseが使われることはない.
        this.urlBase = 'interest_check_print';
        this.runAPI(Type.InterestCheck);
        break;
      case Type.LiterallyReport:
        // 機能訓練レポート・月選択画面:
        this.urlBase = 'literally_report_select_month';
        break;
      default:
        break;
    }
  }

  /**
   * モフトレチェック用API呼び出しメソッド or モフトレチェック用API呼び出しメソッド.
   *
   * @param {Type} type 各タイプ切り替え.
   * @memberof UserSelectBody
   */
  runAPI(type: Type) {
    // ユーザーのインデックス.
    let firstIndex = 0;
    // 同時実行回数.
    const MULTIPLE_COUNT = 5;
    // 決められた数API実行.
    const runActionAPI = () => {
      // maxCountに相当.
      let existCount = 0;
      for (let i = 0; i < MULTIPLE_COUNT; i++) {
        if (this.props.users[firstIndex + i]) {
          // ACTION.
          if (type === Type.MoffCheck) {
            // モフトレチェック.
            this.props.moffCheckActions.getMoffCheckLastDate(
              this.props.users[firstIndex + i].user_id, this.refElements
            );
          } else if (type === Type.InterestCheck) {
            // 興味関心チェック.
            this.props.interestCheckActions.getInterestCheckLastDate(
              this.props.users[firstIndex + i].user_id, this.refElements
            );
          }

          existCount++;
        }
      }

      // maxCountの返却.
      return existCount;
    };
    // 実行した回数.
    let maxCount = runActionAPI();
    // Promise内部用のため.
    let me = this;

    Promise.resolve().then(function loop(): any {
      return new Promise(function(resolve: any, reject: any) {
        setTimeout(function() {
          let isOK = false;

          // 各項目でpropsを切り替え.
          if (type === Type.MoffCheck) {
            // モフトレチェック.
            isOK = (me.props.moffCheckCount.type === MoffCheckConst.FINISH)
              && (me.props.moffCheckCount.LoadedCount === maxCount);
          } else if (type === Type.InterestCheck) {
            // 興味関心チェック.
            isOK = (me.props.interestCheck.type === InterestCheckConst.FINISH)
              && (me.props.interestCheck.LoadedCount === maxCount);
          }

          if (isOK) {
            firstIndex += MULTIPLE_COUNT;
            maxCount = runActionAPI();
            // なくなったらやめる.
            if (maxCount === 0) {
              return;
            }
          }
          // 0.1秒間隔チェック.
          resolve();
        },         100);
      })
      .then(loop);
    });
  }

  /**
   *
   *
   * @readonly
   * @static
   * @memberof UserSelectBody
   */
  static get contextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  /**
   * コンポーネントマウント後.
   *
   * @returns
   * @memberof UserSelectBody
   */
  componentDidMount() {
    // 個別機能訓練に関する記録のときは曜日で行うがそれ以外は何もしない.
    if (this.props.type !== Type.Kiroku) {
      return;
    }

    // 個別機能訓練に関する記録のときの本日の曜日の処理.
    const todayDay: string = UserListField.WEEK_CHARS[new Date().getDay()]; 

    // デフォルトはその曜日なのでそれでinexを取得する.
    const weekSelected: string = todayDay;

    // userのオブジェクトの入ったhiddenのClass.
    let usersObject: HTMLCollectionOf<Element> = document.getElementsByClassName('user');
    // ここから曜日フィルター.
    let index: number = 0;
    for (const key in usersObject) {
      if (usersObject.hasOwnProperty(key)) {
        // 1つのエレメント.
        const element: Element = usersObject[key];
    
        // stringfyで入ってるのでいったん変換.
        const userVisitDay: number[] = (JSON.parse(element.innerHTML) as UserListField.User).user_visit_day;
    
        const parent: HTMLElement | null = element.parentElement;
        // 選択されたWeekSelectedがWeekChars[]の中では何番目の値なのか？
        const weekIndex = UserListField.START_MO_WEEK_CHARS.indexOf(weekSelected);
    
        // 選択したのがAll or 1なら入ってる.
        if (weekSelected === UserListField.ALL || userVisitDay[weekIndex] === 1) {
          if (parent) {
            // 居る人は表示する.
            parent.hidden = false;
    
            // 偶数は白/奇数グレー(cssがhidden要素をスキップしてくれないので上書き).
            const isEven: boolean = index % 2 === 0;
            [].forEach.call(parent.childNodes, (child: Node) =>
              (child as HTMLElement).style.background = isEven ? '#fff' : '#e8e4df'
            );
    
            index++;
          }
        } else {
          if (parent) {
            // 該当しない人は消す.
            parent.hidden = true;
          }
        }
      }
    }
  }

  /**
   * 一覧をクリックしたときの処理.
   *
   * @memberof UserSelectBody
   */
  handleFieldClicked = (userId: string) => {
    // 居宅訪問 pr 興味関心チェック.
    if (this.props.type === Type.HomeVisit || this.props.type === Type.InterestCheck) {
      // 親HomeVisitコンポーネントの処理.
      this.context.callbackParent(userId);
      return;
    }

    // 詳細画面への導線.
    window.location.href = `${this.urlBase}/${userId}`;
  }

  /**
   * JSX描画.
   *
   * @returns
   * @memberof UserSelectBody
   */
  render() {
    if (typeof this.props.users === 'undefined') {
      return(
        <tr>
          <th scope="row">
            Error.
          </th>
          <td />
          <td />
          <td />
          <td />
        </tr>
      );
    }

    // 記録.
    const isKirokuDate: boolean = (this.props.type === Type.Kiroku);
    const elements: HTMLElement[] = this.refElements;
    const userFields = this.props.users.map((user: UserListField.User, i: number) => {
      let latestDate: string = '';

      // 本日かどうか.
      let isToday: boolean = false;

      if (isKirokuDate) {
        const today: string = getCurrentTime().day; // 今日 yyyy-mm-dd

        // undefinedのもあるのでチェックする.
        if (user.functional_latest_date) {
          const theDay = convertTime(user.functional_latest_date);

          // 最新の記録日は年月日の隙間の記号は"/"ではなく"-".
          isToday = (today === theDay[0].replace(/\//g, '-'));
          if (isToday) {
            latestDate = '本日';
          } else {
            latestDate = theDay[0];
          }
        }
      }

      // 日付.
      let date = '';
      if (isKirokuDate) {
        date = latestDate;
      } else if (this.props.type === Type.MoffCheck || this.props.type === Type.InterestCheck) {
        // モフトレチェック, 興味関心チェックでは呼ばない.
      } else {
        date = user.created_at;
      }

      return(
        <tr key={user.user_id} onClick={event => this.handleFieldClicked(user.user_id)}>
          <th scope="row">{user.user_care_id}</th>
          {/* hiddenで隠しておくuserの内容. */}
          <td className="user" hidden={true}>{JSON.stringify(user)}</td>
          <td>{user.user_name}</td>
          <td>{user.user_birth_year}</td>
          <td>{user.user_gender === 0 ? UserListField.Male : UserListField.Female}</td>
          {/* 本日のときは文字色が違う. 最新の記録日 or 登録日の切り替え. */}
          <td className={isToday ? 'kirokuToday' : ''} ref={(item: any) => { elements[user.user_id] = item; }}>
            {date}
          </td>
        </tr> 
      );
    });

    return (
      // {}は不要.
      userFields
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserListField.tsx